import React, {useEffect} from "react";
import Table from "../../components/Table";
import PromoCodeItem from "./PromoCodeItem";
import GraphQLErrors from "../../components/GraphQLErrors";
import gql from "graphql-tag";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import PaginatorButton from "../../components/PaginatorButton";
import withFiltersAndSorting, {SORTING_DIRECTIONS} from "../../lib/WithFiltersAndSorting";
import {connect} from "react-redux";

const PromoCodesList = (props) => {
  const {loading, error, promoCodes} = props.data;

  useEffect(() => {
    const unsubscribeToUpdates = props.subscribeToUpdates(props);
    const unsubscribeToNewData = props.subscribeToNewData(props);

    return () => unsubscribeToUpdates() && unsubscribeToNewData();
  }, []);

  if (error) return <GraphQLErrors error={error} />
  
  // While content is loading we set data as empty array
  const data = fromJS(promoCodes || []);

  const handleItemClick = (itemData, e, field = "") => {
    const id = itemData.get("code");
    props.onSelectionChange(id);
  }
  const handleNext = (afterId) => {
    props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          promoCodes: {
            __typename: prev.promoCodes.__typename,
            metadata: fetchMoreResult.promoCodes.metadata,
            entries: [...prev.promoCodes.entries, ...fetchMoreResult.promoCodes.entries]
          }
        }
      },
    });
  }

  return (
    <div>
      <Table
        loading={loading}
        data={data.get("entries")}
        renderer={PromoCodeItem}
        tableHeader={props.tableColumns}
        createFilteringInput={props.createFilteringInput}
        createSortingArrows={props.createSortingArrows}
        mode="table"
        onItemClick={(itemData, e, field) => handleItemClick(itemData, e, field)}
        itemKey="code"
        showCount={true}
        selected={props.selectedId}
        />
      <PaginatorButton
        metadata={data.get("metadata")}
        onNext={handleNext}
        />
    </div>
  );
}


const PROMO_CODES = gql`
  query promoCodes($filter:PromoCodesFilterInput, $pagination:PaginationInput, $sortOrders:[SortingInput]) {
    promoCodes(filter:$filter, pagination: $pagination, sortOrders: $sortOrders) {
      entries {
        code
        type
        description
        percentage
        restrictionType
        subscriptionsOnly
        tagRules
        useCount
        status
        expiryDate
        limit
        batchClient
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

const ON_NEW_CODE = gql`
  subscription {
    newPromoCode {
      code
    }
  }
`;

const ON_UPDATED_CODE = gql`
  subscription {
    updatedPromoCode {
      code
    }
  }
`;


const withQuery = graphql(PROMO_CODES, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        ...props.filters,
        promoCodeFilter: props.promoCodesFilter,
      },
      sortOrders: props.sortOrders,
    },
  })
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  subscribeToNewData: (props) => {
    return props.data.subscribeToMore({
      document: ON_NEW_CODE,
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  },
  subscribeToUpdates: (props) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_CODE,
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  },
});

const withGraphQL = connect(null, mapDispatchToProps)(withQuery(PromoCodesList));

export default withFiltersAndSorting(withGraphQL, {
  tableColumns: (props) => [
    { title: "Code", id: "code" },
    { title: "Type", id: "type" },
    { title: "Description", id: "description" },
    { title: "Percentage" },
    { title: "Restrictions" },
    { title: "Use Count" },
    { title: "Expiry Date" },
    { title: "Status", id: "status" },
  ],
  defaultSortings: [
    {name: "status", direction: SORTING_DIRECTIONS.DESC}, 
    {name: "use_count", direction: SORTING_DIRECTIONS.DESC},
    {name: "created_at", direction: SORTING_DIRECTIONS.DESC}]
});
